import React from 'react'

import './HomeSection3.css'

import homeServices1 from "../../../../assets/imgs/homeServices1.png"

function HomeSection3() {
  return (
    <div className='hs1' style={{
      overflow: 'hidden',
    }}>
    <span className='hs1-head'>SERVICES</span>
   <span className='hs1-title'>Services we provide</span>
   <div className='hs3-inner'>

   <div className='hs3-card'>
        
            <img src={homeServices1} alt="" />
            <span>ULTRA LOW POWER DESIGN</span>
            <p>Ultra Low Power Products Design Service. Battery Powered System run upto 10 Years of Battery Life.</p>

       
    </div>
   <div className='hs3-card'>
        
            <img src={homeServices1} alt="" />
            <span>ULTRA LOW POWER DESIGN</span>
            <p>Ultra Low Power Products Design Service. Battery Powered System run upto 10 Years of Battery Life.</p>

       
    </div>
   <div className='hs3-card'>
        
            <img src={homeServices1} alt="" />
            <span>ULTRA LOW POWER DESIGN</span>
            <p>Ultra Low Power Products Design Service. Battery Powered System run upto 10 Years of Battery Life.</p>

       
    </div>
   <div className='hs3-card'>
        
            <img src={homeServices1} alt="" />
            <span>ULTRA LOW POWER DESIGN</span>
            <p>Ultra Low Power Products Design Service. Battery Powered System run upto 10 Years of Battery Life.</p>

       
    </div>
   </div>
    </div>
  )
}

export default HomeSection3
